import { Dispatch, SetStateAction } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import { EmailAccountMethod } from '../../../../enums/email-account';

import EmailDailySendingLimit from './email-daily-sending-limit';
import { resetUpdateSendingLimitsRequestState } from './email-daily-sending-limit-slice';
import {
  getEspLimitsRequest,
  updateSendingLimitsRequest,
} from './extra-actions';

import { FeatureUsage } from '../../../../../../shared/types/feature-usage';
import {
  connectEmailAccountRequest,
  getEmailAccountSettingsRequest,
  getEmailAccountSetupScoreRequest,
} from '../../../../extra-actions';
import { getConnectedUsersAndEmailAccountsRequest } from '../../../../../settings/components/billing-subscription/extra-actions';
import { resetConnectedUsersAndEmailAccountsRequest } from '../../../../../settings/components/billing-subscription/billing-subscription-slice';
import { EmailAccountSetupScorePayload } from '../../../../types/request-payload';

const mapStateToProps = (state: RootState) => ({
  subscriptionPlan: state.home.subscription?.planCode,
  role: state.home.role,
  connectEmailAccountRequestStatus:
    state.emailAccount.connectEmailAccountRequest.status,
  getEspLimitsRequestStatus:
    state.emailDailySendingLimit.getEspLimitRequest.status,
  espLimits: state.emailDailySendingLimit.espLimits,
  inboxEspLimits: state?.emailDailySendingLimit?.inboxAnalyzerEsps,
  emailAccount: state.emailAccount.emailAccount,
  emailAccountSettings: state.emailAccount.emailAccountSettings,
  updateSendingLimitsStatus:
    state.emailDailySendingLimit.updateSendingLimitsRequest.status,
  firstName: state.home.adminDetails?.firstName,
  getConnectedUsersAndEmailAccountsRequestStatus:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest
      .status,
  totalEmailAccounts:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse
      ?.totalEmailAccounts,
  emailAccountQuota: state.home.subscription?.emailAccountQuota,
});

const mapDispatchToProps = {
  sendConnectEmailAccountRequest: (
    method: EmailAccountMethod,
    emailAccountId?: number,
  ) => connectEmailAccountRequest({ method, emailAccountId }),
  sendGetEspLimitRequest: () => getEspLimitsRequest(),
  sendUpdateSendingLimitsRequest: (payload: {
    emailAccountId: number;
    maxSendingLimit?: number;
    inboxPlacementDailySendingLimit?: number;
  }) => updateSendingLimitsRequest(payload),
  sendGetEmailAccountSettingsRequest: (hashId: string) =>
    getEmailAccountSettingsRequest(hashId),
  resetUpdateSendingLimitsRequestState: () =>
    resetUpdateSendingLimitsRequestState(),
  sendGetConnectedUsersAndEmailAccountsRequest: () =>
    getConnectedUsersAndEmailAccountsRequest(),
  resetConnectedUsersAndEmailAccountsRequest: () =>
    resetConnectedUsersAndEmailAccountsRequest(),

  sendGetEmailAccountSetupScoreRequest: (
    payload: EmailAccountSetupScorePayload,
  ) => getEmailAccountSetupScoreRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  isBulkUpdatingEmailAccounts?: boolean;
  setSendingLimit?: Dispatch<SetStateAction<number>>;
  setInboxSendingLimit?: Dispatch<SetStateAction<number>>;
  setSendingLimitError?: Dispatch<SetStateAction<boolean>>;
  setSendingInboxLimitError?: Dispatch<SetStateAction<boolean>>;
  featureUsages: FeatureUsage[];
};

export default connector(EmailDailySendingLimit);
